import { mapObjectToArray } from "@exonn/utils";

import type { GridLogicOperator } from "@mui/x-data-grid-pro";
import {
  ResourceListSearchParams,
  type UrlFilterModel,
  type UrlState,
} from "src/system/useResourceList/useResourceList.types.ts";

export const convertUrlStateToGridState = (gridUrlState: UrlState) => {
  const paginationModel = {
    page: gridUrlState[ResourceListSearchParams.Page] ?? 0,
    pageSize: gridUrlState[ResourceListSearchParams.PageSize] ?? 0,
  };
  const sortModelFromUrl = gridUrlState[ResourceListSearchParams.SortModel];
  const sortModel = mapObjectToArray(sortModelFromUrl || {}, (value, key) => {
    return {
      field: key,
      sort: value,
    };
  });

  const appliedFilterModelFromUrl =
    gridUrlState[ResourceListSearchParams.FilterModel];
  const nonAppliedFilterModelFromUrl =
    gridUrlState[ResourceListSearchParams.NotAppliedFilterModel];
  const logicOperator =
    gridUrlState[ResourceListSearchParams.FilterModelLogicOperator];

  return {
    filterModel: mapUrlFilterModelToGridFilterModel(
      appliedFilterModelFromUrl || {},
      logicOperator,
    ),
    notAppliedFilterModel: mapUrlFilterModelToGridFilterModel(
      nonAppliedFilterModelFromUrl || {},
      logicOperator,
    ),
    paginationModel,
    sortModel,
  };
};

const mapUrlFilterModelToGridFilterModel = (
  urlFilterModel: UrlFilterModel,
  logicOperator: GridLogicOperator | undefined,
) => {
  return {
    logicOperator: logicOperator,
    items: mapObjectToArray(urlFilterModel || {}, (value, key, index) => {
      return {
        field: key,
        id: index,
        value: value.v,
        operator: value.o,
      };
    }),
  };
};
